import {agreements, env, redirectionErrorCodes} from "../constants/global.vars";
import {authSubject, auth, loginModalSubject} from "../store/auth.store";
import {Storage} from "./localstorege.service";
import {Member} from "../models/auth.model";
import {modalServiceSubject} from "./modal.service";
import {exceptionModal, useForceUpdate} from "./misc.functions";
import paths from "../paths";
import {ApiService} from "../lib/http.service";
import React, {useEffect, useState} from "react";
import ReactInputMask from "react-input-mask";
import {MobileValidationModal} from "../pages/login/mobileValidationModal";
import {wssProvider} from "./websocket.service";
import {toast} from "react-toastify";
import {professions} from "../constants/basic.constants";
import InputAuto from "../pages/register/input.auto";

export const financialValidationApprove: { data: any } = {data: null};

export function restoreLogin() {
    let savedData: any = Storage.get("member");
    if (savedData) {
        auth.member = new Member(savedData);
        auth.token = Storage.get("token");
        auth.authentication = true;
    }
}

export async function userLogin(payload: any) {

}


export function userWsLogout() {
    auth.member = null;
    auth.token = null;
    auth.authentication = false;

    Storage.del("token");
    Storage.del("member");

    authSubject.next({action: "logout"});
    loginModalSubject.next(false);
}

export function userLogout() {

    modalServiceSubject.next({
        title: 'Oturumu Kapat',
        content: `Oturumu kapatmak istediğinize emin misiniz?`,
        case: 'info',
        confirm: {
            sure: {
                label: 'Oturumu Kapat',
                action: () => {
                    auth.member = null;
                    auth.token = null;
                    auth.authentication = false;

                    Storage.del("token");
                    Storage.del("member");

                    authSubject.next({action: "logout"});
                    loginModalSubject.next(false);
                }
            },
            cancel: {
                label: 'Vazgeç',
            }
        }
    })


}

export function sendValidationCode(payload: any) {
    let api = new ApiService();
    api
        .start("post", env.api + "/member/api/validation-member-sms/", payload, false)
        .then((res: any) => {
        })
        .catch((e: any) => {
            exceptionModal(e);
        });
}

export async function userValidation(payload: any, resend: any = false) {
    if (resend) {
        sendValidationCode(payload);
    }

    let mobile = payload.mobile;
    let s: any = null;
    let sureButton: any = null;
    let resendButton: any = null;
    let validationErrorMessage: any = null;
    const senderTimer = (s: any = null) => {
        let resendTimer: any = document.getElementById("id_resendTimer");
        if (resendTimer) {
            let secondLeft: number = Number(
                Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1
            );
            if (secondLeft < 0) {
                clearInterval(s);
                if (resendButton) {
                    resendButton.style.display = "block";
                }
            } else {
                resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
            }
        }
    };

    modalServiceSubject.next({
        title: "Doğrulama Kodu",
        innerHtml: true,
        greenBg: true,
        confirm: {
            sure: {
                label: "Doğrula",
                autoClose: false,
                async: true,
                action: async () => {
                    validationErrorMessage.style.display = "none";
                    const inputElements: any = document.querySelectorAll("input.code-input");
                    let validateCodeValue = [...inputElements].map((inp: any) => inp.value).join("");
                    let api = new ApiService();
                    return await api
                        .start(
                            "post",
                            env.api + "/member/api/update-account-info/",
                            {
                                mobile: mobile.replaceAll(' ', ''),
                                sms_verify_code: validateCodeValue,
                            },
                            true
                        )
                        .then((res: any) => {
                            if (res && res.status) {
                                auth.userValidation = true;
                                try {
                                    auth.member.mobile_validation = true;
                                    auth.member.mobile = mobile.replaceAll(' ', '');
                                } catch (e: any) {
                                    console.error(e);
                                }
                                return true;
                            } else {
                                if (validationErrorMessage) {
                                    validationErrorMessage.style.display = "block";
                                    validationErrorMessage.innerHTML = res.message;
                                }
                            }
                        })
                        .catch((e: any) => {
                            if (validationErrorMessage) {
                                validationErrorMessage.style.display = "block";
                                validationErrorMessage.innerHTML = e;
                            }
                        });
                },
            },
        },
        onClose: () => {
            clearInterval(s);
        },
        afterLoad: () => {
            s = setInterval(senderTimer, 1000);
            validationErrorMessage = document.getElementById("id_validationErrorMessage");
            if (validationErrorMessage) {
                validationErrorMessage.style.display = "none";
            }
            sureButton = document.getElementById("id_btnModelServiceSure");
            resendButton = document.getElementById("id_resendCode");


            if (sureButton) {
                sureButton.disabled = true;
            }
            if (resendButton) {
                resendButton.style.display = "none";
                resendButton.addEventListener("click", (e: any) => {
                    resendButton.style.display = "none";
                    let resendTimer: any = document.getElementById("id_resendTimer");
                    if (resendTimer) {
                        if (validationErrorMessage) {
                            validationErrorMessage.style.display = "none";
                        }

                        sendValidationCode(payload);
                        resendTimer.innerHTML = "3:00";
                        clearInterval(s);
                        s = setInterval(senderTimer, 1000);
                    }
                });
            }

            const inputElements: any = document.querySelectorAll("input.code-input");
            inputElements.forEach((ele: any, index: any) => {
                ele.addEventListener("keydown", (e: any) => {
                    if (e.keyCode === 8 && e.target.value === "") inputElements[Math.max(0, index - 1)].focus();
                });
                ele.addEventListener("input", (e: any) => {
                    const [first, ...rest] = e.target.value;
                    e.target.value = first ?? ""; // first will be undefined when backspace was entered, so set the input to ""
                    const lastInputBox = index === inputElements.length - 1;
                    const didInsertContent = first !== undefined;
                    if (didInsertContent && !lastInputBox) {
                        // continue to input the rest of the string
                        inputElements[index + 1].focus();
                        inputElements[index + 1].dispatchEvent(new Event("input"));
                    }

                    let validateCodeValue = [...inputElements].map((inp: any) => inp.value).join("");
                    if (validateCodeValue.length === 6) {
                        sureButton.disabled = false;
                    } else {
                        sureButton.disabled = true;
                    }
                });
            });
        },

        content: `
     
        
        
             <div class="pt-4 mb-4 pb-1">
                <p class="text-md  text-center">
                    <span class="text-md text-primary text-bold">${mobile} </span>numaralı
                    telefona gelen 6 haneli <br/> doğrulama kodunu gir.</p>
            </div>
        </div>
        
        <div class="mb-3 d-flex w-100">
            <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
            <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
            <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
            <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
            <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
            <input type="tel" autocomplete="off" name='char' maxlength="1" class='code-input col-auto' required/>
            <div class="clearfix"></div>
        </div>
        <div id="id_validationErrorMessage" class="text-center text-danger alert alert-danger"></div>
        
         <div class="row mb-4">
                <div class=" col-12  d-flex justify-content-center align-items-center mb-1">
                    <p class="text-small">Kalan Süre</p>
                </div>
                <div class=" col-12  d-flex justify-content-center align-items-center">
                    <div id="emailHelp" class="form-text"><span id="id_resendTimer">3:00</span></div>
                </div>
            </div>
      <button style="bottom: 8px;display: none;" class="button tertiary filled" id="id_resendCode">Tekrar Gönder</button>
      <div>
      
     `,
    });
}

export async function sendEmailValidationLink(email: any) {
    let api = new ApiService();
    api
        .start(
            "post",
            env.api + "/member/api/validation-email/",
            {
                type: "register_send",
                email: email,
                return_address: `${window.location.protocol}//${window.location.host}${paths.verifyEmail.url}`,
            },
            true
        )
        .then((res: any) => {
            if (res && res.status) {
                modalServiceSubject.next({
                    title: '',
                    innerHtml: true,
                    width: '472px',
                    content: `   <div>
                                            <div class="mb-1 d-flex justify-content-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"
                                                     viewBox="0 0 80 80" fill="none">
                                                    <path
                                                        d="M13.5 30L31.5438 38.8517C36.8777 41.4683 43.1223 41.4683 48.4562 38.8517L66.5 30"
                                                        stroke="#1F3735" strokeWidth="4" stroke-linecap="round"></path>
                                                    <rect x="6.5" y="14" width="67.2" height="53.6" rx="10.8"
                                                          stroke="#1F3735" strokeWidth="4"></rect>
                                                </svg>
                                            </div>
                                            <p class="text-md  text-bolder text-center mb-1">Posta kutunuzu kontrol
                                                edin</p>
                                            <p class="text-small text-center mb-1">Doğrulama linki mail adresinize
                                                gönderilmiştir.</p>

                                        </div>`,
                    confirm: {
                        sure: {
                            label: "Tamam",
                        },
                    },
                });
            } else {
                modalServiceSubject.next({
                    case: 'danger',
                    title: '',
                    width: '472px',
                    innerHtml: true,
                    content: `
                        <p class="text-xsmall text-center" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                                <path
                                    d="M49.9993 30L29.9993 50M29.9993 30L49.9993 50M73.3327 40C73.3327 58.4095 58.4088 73.3334 39.9993 73.3334C21.5899 73.3334 6.66602 58.4095 6.66602 40C6.66602 21.5905 21.5899 6.66669 39.9993 6.66669C58.4088 6.66669 73.3327 21.5905 73.3327 40Z"
                                    stroke="#E04C4C" strokeWidth="4" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </p>
                        <div style="height: 16px;"></div>
                        <p class="text-lg text-bolder text-center" >Hata Oluştu.</p>
                        <div style="height: 16px;"></div>
                        <p class="text-small text-center" >${res.message}</p>
                    `,
                    confirm: {
                        sure: {
                            label: "Tamam",
                        },
                    },
                });
            }
        });
}


export const callChangePhone = (username: string, password: string, mobile: string) => {
    var payload = {
        username: username,
        password: password,
        mobile: mobile.replaceAll(' ', '')
    }
    const api = new ApiService()
    api.start('post', env.api + '/member/api/change-mobile/', payload, true, 3000)
        .then((res: any) => {
            if (res.status) {
                res.data.verify_message = null;
                modalServiceSubject.next({
                    title: "Hesap Aktivasyonu",
                    height: 'auto',
                    content: <MobileValidationModal result={res} password={password}
                                                    username={username}></MobileValidationModal>,
                    confirm: {
                        cancel: {
                            label: 'Vazgeç',
                            action: () => {

                            }
                        }
                    },
                    timeout: 0
                })

            } else {
                modalServiceSubject.next({
                    show: true,
                    title: "Hatalı giriş!",
                    // İçerik HTML; bayrak olmadan kullanıcı "<div class=..." metnini görüyordu.
                    innerHtml: true,
                    content: '<div class="p-3"><p class="text-center">' + res.message + '</p></div>',
                    confirm: {
                        cancel: {label: 'Tamam'}
                    },
                    timeout: 0
                })
            }


        });

}


export const callLoginApi = (username: string, password: string, option: any = null) => {

    let api = new ApiService();
    api
        .start("post", env.api + "/member/api/login/", {
            user: username,
            password: password,
            ...option
        }, false)
        .then((res: any) => {
            if (res && res.status) {
                auth.member = new Member(res.data.member);
                auth.token = res.data.token;
                auth.authentication = true;
                Storage.set("token", res.data.token);
                Storage.set("member", res.data.member);
                authSubject.next({action: "login"});
                wssProvider.user(auth.token);
                window.location.replace(paths.home.url);
            } else if (res.error === "sms_validate") {
                modalServiceSubject.next({
                    title: "Hesap Aktivasyonu",
                    greenBg: true,
                    innerHtml: true,
                    height: 'auto',
                    onclose: () => {
                        let loginButton: any = document.getElementById("id_btnLogin");
                        if (loginButton) {
                            loginButton.disabled = false;
                        }
                    },
                    content: <MobileValidationModal result={res} password={password}
                                                    username={username}></MobileValidationModal>,
                    confirm: {
                        cancel: {
                            label: 'Vazgeç',
                            action: () => {
                            }
                        }
                    },
                    timeout: 0
                })
            } else if (res.error === "agreement_required") {
                let content = agreements["kullanim-sartlari"];
                modalServiceSubject.next({
                    title: content.title,
                    content: content.content,
                    greenBg: true,
                    innerHtml: true,
                    width: 720,
                    onclose: () => {
                        let loginButton: any = document.getElementById("id_btnLogin");
                        if (loginButton) {
                            loginButton.disabled = false;
                        }
                    },
                    confirm: {
                        cancel: {
                            label: "Vazgeç",
                        },
                        sure: {
                            label: "Kabul Et",
                            class: "btn-info  w-100",
                            action: () => {
                                callLoginApi(username, password, {is_checked: true});
                            },
                        },
                    },
                });
            } else if (res.error === 'financial_validation') {
                wssProvider.setFinancialValidationListener(res.data.key);
                let copyName: any = null;
                let copyIban: any = null;
                modalServiceSubject.next({
                    title: "Finansal Doğrulama",
                    width: '700px',
                    height: 'auto',
                    innerHtml: true,
                    greenBg: true,
                    afterLoad: () => {
                        copyName = document.getElementById("copy-name");
                        copyIban = document.getElementById("copy-iban");


                        if (copyName) {
                            copyName.addEventListener("click", (e: any) => {
                                navigator.clipboard.writeText('T ŞANS OYUNLARI A.Ş.').then(() => {
                                    toast.success("Kopyalandı.");

                                });
                            });
                        }
                        if (copyIban) {
                            copyIban.addEventListener("click", (e: any) => {
                                navigator.clipboard.writeText('TR30 0001 0022 5097 7884 0450 01').then(() => {
                                    toast.success("Kopyalandı.");

                                });
                            });
                        }

                    },
                    onClose: () => {
                        let loginButton: any = document.getElementById("id_btnLogin");
                        if (loginButton) {
                            loginButton.disabled = false;
                        }
                        if (financialValidationApprove.data != null && financialValidationApprove.data.data.status) {
                            callLoginApi(username, password);
                        }

                    },
                    content: `<div class="financial-validation"> <div class="card-body">
        <div class="otherBanks">
            <div class="d-flex justify-content-center align-items-center">
                <h3>Tebrikler!</h3>
            </div>
            <div class="d-flex justify-content-center align-items-center">
                <h6 style="text-align: center">Bilgileriniz başarılı bir şekilde kaydedilmiştir.</h6>

            </div>
            <div class="explanation-area">
                01 Şubat 2026 tarihi itibarıyla, tüm bayilerde olduğu gibi yasal düzenlemeler gereği  para yatırma işleminden sonra üyelik işlemleriniz tamamlanacaktır.

                Bu kapsamda, 72 saat içinde, kimlik bilgileriniz ile uyumlu ve adınıza kayıtlı TL vadesiz banka hesabınızdan, anlaşmalı bankalarımız aracılığıyla Şans Oyunu Ödemesi yapabilir veya aşağıda belirtilen IBAN’a para transferi gerçekleştirebilirsiniz.


            </div>
            <div>
                <h3>Banka Hesap Bilgilerimiz</h3>


                    <div class="d-felx justify-content-between align-items-center">
                        <div>Alıcı İsmi:</div>
                        <div class="clickable-td text-end d-flex justify-content-end align-items-center">T ŞANS OYUNLARI A.Ş. <div class="deposit-copy" id="copy-name">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <rect x="4.23779" y="2.08345" width="5.67949" height="5.68011" rx="1.25"
                                                      stroke="#353535" stroke-width="1.5">
                                                </rect>
                                                <path
                                                    d="M7.84632 9.23151V9.23151C7.84632 10.0246 7.20339 10.6675 6.41029 10.6675H3.3335C2.22893 10.6675 1.3335 9.7721 1.3335 8.66753V5.59004C1.3335 4.79702 1.97637 4.15414 2.76939 4.15414V4.15414"
                                                    stroke="#353535" stroke-width="1.5">
                                                </path>
                                            </svg>
                                            Kopyala
                                        </div>

                                        </div>
                    </tr>
                    <div class="d-felx justify-content-between align-items-center">
                        <div>Ziraat Bankası IBAN:</div>
                        <div class="clickable-td text-end d-flex justify-content-end align-items-center" >TR30 0001 0022 5097 7884 0450 01
                         <div class="deposit-copy" id="copy-iban">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <rect x="4.23779" y="2.08345" width="5.67949" height="5.68011" rx="1.25"
                                                      stroke="#353535" stroke-width="1.5">
                                                </rect>
                                                <path
                                                    d="M7.84632 9.23151V9.23151C7.84632 10.0246 7.20339 10.6675 6.41029 10.6675H3.3335C2.22893 10.6675 1.3335 9.7721 1.3335 8.66753V5.59004C1.3335 4.79702 1.97637 4.15414 2.76939 4.15414V4.15414"
                                                    stroke="#353535" stroke-width="1.5">
                                                </path>
                                            </svg>
                                            Kopyala
                                        </div>

                                        </div>
                    </div>

            </div>
            <div class="mt-4">
                Para transferi tamamlanana kadar üyeliğiniz aktif hale getirilemeyecek ve hizmet sunulamayacaktır.
                Transferin başarıyla tamamlanmasını takiben üyeliğiniz aktif hale gelecek, yatırılan tutar üye bakiyenize yansıtılacaktır.
            </div>
        </div>
    </div> </div>`,
                    confirm: {
                        cancel: {
                            label: 'Vazgeç',
                            action: () => {
                            }
                        }
                    },
                    timeout: 0
                })
            } else if (res.error === "profession_error") {
                let picked: any = null;
                const onSelected = (p: any) => (picked = p);

                const content = React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                        "p",
                        {className: "mb-3 mt-3"},
                        "Yasal gereklilikler nedeniyle iş ve meslek bilginizi kaydetmeniz gerekmektedir. Lütfen iş ve meslek bilginizi seçiniz"
                    ),
                    React.createElement("form", null, React.createElement(
                        "div",
                        {className: "form-row"},
                        React.createElement(
                            "div",
                            {className: "w-100"},
                            React.createElement(InputAuto, {
                                label: "Meslek",
                                data: professions,
                                onSelected: onSelected,
                            })
                        )
                    ),),
                    React.createElement(
                        "p",
                        {id: "errorMessage", className: "mt-1 text-danger"},
                        ""
                    )
                );

                setTimeout(() => {
                    modalServiceSubject.next({
                        title: "Meslek Bilginizi Seçin",
                        cancelBackdrop: true,
                        content: content,
                        greenBg: true,
                        confirm: {
                            sure: {
                                label: "Kaydet",
                                autoClose: false,
                                async: true,
                                action: async () => {
                                    if (picked) {
                                        callLoginApi(username, password, {profession: picked.value});
                                    } else {
                                        const errEl = document.getElementById(
                                            "errorMessage"
                                        );
                                        if (errEl)
                                            errEl.innerText = "Lütfen meslek seçiniz.";
                                        return false;
                                    }
                                },
                            },
                        },
                        timeout: 0,
                    });
                }, 1000);
            } else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata",
                    width: 380,
                    content: `${res.message}`,
                    confirm: {
                        cancel: {
                            label: "Tamam",
                            class: "btn-danger",
                        },
                        sure: redirectionErrorCodes.includes(res.error)
                            ? {
                                label: "Giriş yap",
                                action: () => {
                                    window.location.href = paths.login.url;
                                },
                            }
                            : null,
                    },
                });
            }
        })
        .catch((e: any) => {
            return {status: false, error: e, message: e, data: null};
        });
}

